export default __webpack_public_path__ + "files/FP11_Synergies_between_different_funding_programmes.docx";